import { convertGeometryToOpenLayers, Geometry3 } from "../geom"
import { isObject } from "../utils/utils"
import { ol_geom } from "@omnia/exports/openlayers";

export function createGeometryCache<T>(boundarySelector: (item: T) => Geometry3) {

    const cache = new WeakMap<any, ol_geom.Geometry>()

    return (item: T) => {

        const b = boundarySelector(item)

        if (!b) {
            return undefined
        }

        let g = cache.get(b)

        if (!g) {

            g = convertGeometryToOpenLayers(boundarySelector(item))

            if (isObject(b)) {
                cache.set(b, g)
            }

        }
        else {

            g = (<any>g).clone()

        }

        return g

    }
}
